import { LayerDef } from "../../type/asset";

export class LayerAdapter {
  static toOutputDTO(res: any): LayerDef {
    const balanceKeys = [
      "dashboard-new-asset-balance-attr1",
      "dashboard-new-asset-balance-attr2",
      "dashboard-new-asset-balance-attr3",
    ];

    const transformLayer = () =>
      Object.entries(res).map(([_, value], index) => ({
        id: index,
        key: balanceKeys[index],
        value,
      }));

    const balance1 = transformLayer();
    const balance2 = transformLayer();

    return [
      { id: 1, key: "dashboard-new-asset-balance-title1", values: balance1 },
      { id: 2, key: "dashboard-new-asset-balance-title2", values: balance2 },
    ];
  }
}
